import styled from '@emotion/styled'
import { css, keyframes } from '@emotion/react'

import { colors } from '../../styles/theme'
import media from '../../styles/media'

const S = {}

const gradientSwipe = keyframes`
  from {
    transform: translateX(-50%);
  }
  to {
    transform: translateX(25%);
  }
`

S.Loading = styled.div`
  color: ${colors.woodsmoke};

  ${({ isAlternateColor }) =>
    isAlternateColor &&
    css`
      color: ${colors.shark};
      opacity: 0.6;
    `};

  ${({ isAnimated }) =>
    isAnimated &&
    css`
      div:not(.button-group) {
        position: relative;
        overflow: hidden;

        @media (prefers-reduced-motion: no-preference) {
          &::after {
            content: '';
            display: block;
            position: absolute;
            background: linear-gradient(
              130deg,
              rgba(35, 37, 43, 0.1) 10%,
              rgba(73, 76, 86, 0.2) 25%,
              rgba(73, 76, 86, 0.2) 30%,
              rgba(35, 37, 43, 0.1) 45%
            );
            width: 400%;
            height: 100%;
            animation: ${gradientSwipe} 1.4s cubic-bezier(0.23, 1, 0.32, 1)
              infinite;
          }
        }
      }
    `}
`

S.Title = styled.div`
  width: 75%;
  height: 1.125rem;
  background-color: currentColor;

  &:not(:last-of-type) {
    margin-block-end: 0.75rem;
  }
`
S.Subtitle = styled.div`
  width: 50%;
  height: 0.875rem;
  background-color: currentColor;

  &:not(:last-of-type) {
    margin-block-end: 0.75rem;
  }
`

S.Text = styled.div`
  width: 100%;
  height: 0.875rem;
  background-color: currentColor;

  &:not(:last-of-type) {
    margin-block-end: 0.5rem;
  }
`

S.Button = styled.div`
  width: 100%;
  height: 2.5rem;
  background-color: currentColor;

  ${media.sm`
    width: 9rem;
  `};
`

S.ButtonGroup = styled.div`
  display: flex;

  &:last-of-type {
    margin-block-start: 0.75rem;
  }

  ${media.sm`
    &:last-of-type {
      margin-block-start: 1.25rem;
    }
  `};

  > div:not(:first-of-type) {
    display: none;
    margin-block-start: 0;

    ${media.sm`
      display: block;
      margin-inline-start: 0.625rem;
    `};
  }
`

export default S
